export default __webpack_public_path__ + "static/media/69.162d06a3.gif";